export default __webpack_public_path__ + "static/media/filter_list.0cb0ef88.svg";